import { apiCall } from './gqlClient';

const SENDMESSAGE_QUERY = `
  query sendMessage($data: JSON!) {
    sendMessage(data: $data)
  }`;

export const sendMessageApiCall = async ({data}, ) => apiCall({ query: SENDMESSAGE_QUERY, variables: {data}});

const SENDMESSAGEANAMNESI_QUERY = `
  query sendMessageAnamnesi($data: customerAnamnesiNotificationInput!) {
    sendMessageAnamnesi(data: $data)
  }`;

export const sendMessageAnamnesiApiCall = async ({data}, ) => apiCall({ query: SENDMESSAGEANAMNESI_QUERY, variables: {data}});

const SENDREMINDERSUBSCRIPTION_QUERY = `
  query sendReminderSubscription($subscriptionId: Int!) {
    sendReminderSubscription(subscriptionId: $subscriptionId)
  }`;

export const sendReminderSubscriptionApiCall = async ({subscriptionId}, ) => apiCall({ query: SENDREMINDERSUBSCRIPTION_QUERY, variables: {subscriptionId}});

const SENDREMINDEREXPIRINGMEMBERSHIP_QUERY = `
  query sendReminderExpiringMembership($userMembershipId: Int!) {
    sendReminderExpiringMembership(userMembershipId: $userMembershipId)
  }`;

export const sendReminderExpiringMembershipApiCall = async ({userMembershipId}, ) => apiCall({ query: SENDREMINDEREXPIRINGMEMBERSHIP_QUERY, variables: {userMembershipId}});

const SENDREMINDERTOALLSUBSCRIPTIONINASESSION_QUERY = `
  query sendReminderToAllSubscriptionInASession($sessionId: Int!) {
    sendReminderToAllSubscriptionInASession(sessionId: $sessionId)
  }`;

export const sendReminderToAllSubscriptionInASessionApiCall = async ({sessionId}, ) => apiCall({ query: SENDREMINDERTOALLSUBSCRIPTIONINASESSION_QUERY, variables: {sessionId}});
